import React, { useCallback, useRef, useEffect, useState } from "react";
import {
  Box,
  Button,
  Icons,
  Modal,
  Radio,
  Tooltip,
  Typography,
  useToast,
} from "fds";
import "./index.scss";
import { DocInfo } from "../../types/files";
import utilsDocs from "../../shared/utils/docs";
import { Member } from "../../types/workgroup";
import { nanoid } from "@reduxjs/toolkit";
import { getUserInfoFromLocalStorage } from "../../shared/utils/auth";
import { LoginDto } from "../../types/auth";
import useDocumentStore from "../../redux/dispatcher/useDocumentStore";
import { t } from "i18next";
import NameTag from "../NameTag";

interface ChangeFileMasterModalProps {
  open: boolean;
  onClose: () => void;
  docInfos?: DocInfo[]; // 타겟 문서들
}
const ChangeFileMasterModal: React.FC<ChangeFileMasterModalProps> = ({
  open,
  onClose,
  docInfos,
}) => {
  const user = getUserInfoFromLocalStorage() as string | "";
  const loginDto: LoginDto = JSON.parse(user);
  const myId = loginDto?.userInfo?.userId ?? "";

  /** Hook 정리 */
  const toast = useToast();
  const { changeDocMaster } = useDocumentStore();

  /** State 정리 */
  const [memeberList, changeMemberList] = useState<Member[]>([]); // 워크그룹 멤버 리스트
  const [newMastserUserId, changeNewMasterUserId] = useState(""); // 새 문서 관리자 userId

  /** UseEffect 정리 */
  useEffect(() => {
    if (!docInfos) return;
    changeMemberList([...(docInfos[0]?.workgroup?.members ?? [])]);
  }, [docInfos]);

  /** 함수 정리 */
  /** 문서 관리자 변경 */
  const handleUpdateMasterUser = async () => {
    if (!docInfos) return;
    const resp = await changeDocMaster({
      syncId: docInfos.map((item) => item.syncId),
      fromUserId: myId,
      toUserId: newMastserUserId,
      rev: 0,
    });
    if (resp.payload) {
      toast.toastMsg(
        nanoid(),
        t("file.alert.changeFileOwnerSuccess"),
        "success"
      );
    } else {
      toast.toastMsg(nanoid(), t("file.alert.changeFileOwnerFail"), "error");
    }
    onClose();
  };
  return (
    <Modal
      open={open}
      onClose={onClose}
      isCustom
      width={540}
      height={601}
      style={{ boxSizing: "border-box" }}
      classes="changeMaster"
    >
      <Box classes="changeMaster-header">
        <Box direction="column" width="calc(100% - 35px)">
          <Box alignItems="center">
            <Typography type="h2">{t("file.action.changeOwner")}</Typography>
          </Box>
          <Box classes="mg mt-4" alignItems="center">
            {docInfos && utilsDocs.renderDocIcon(docInfos[0]?.contentName, 24)}
            <Box width={8} />
            <Tooltip
              message={docInfos?.map((item) => item?.contentName).join("\n")}
            >
              <Box width={"100%"}>
                <Typography
                  type="body2_rg"
                  ellipsis
                  maxWidth={docInfos && docInfos.length > 1 ? 325 : 400}
                >
                  {docInfos ? docInfos[0]?.contentName : ""}
                </Typography>
                {docInfos && docInfos.length > 1 && (
                  <Typography
                    type="body2_rg"
                    whiteSpace="pre"
                    classes="mg ml-2"
                  >
                    {t("common.andNOthers", { num: docInfos.length - 1 })}
                  </Typography>
                )}
              </Box>
            </Tooltip>
          </Box>
        </Box>
        <div className="mg ml-auto cursor pointer" onClick={onClose}>
          <Icons variant="line" label="closeLarge" />
        </div>
      </Box>
      <Box direction="column" classes="mg mt-8 changeMaster-members">
        {memeberList
          .filter((user) => user.status === 1)
          .map((item: Member) => (
            <Box alignItems="center" minHeight={50} width="100%">
              <NameTag
                user={item}
                width={"calc(100% - 30px)"}
                withoutUserId={false}
              />
              <Radio
                style={{ marginLeft: "auto" }}
                onClick={() => changeNewMasterUserId(item.userId)}
                check={newMastserUserId === item.userId}
              />
            </Box>
          ))}
      </Box>
      <Box classes="changeMaster-footer--divider" />
      <Box classes="changeMaster-footer">
        <Button
          label={t("common.cancel")}
          btnStyle="fill"
          type="secondary"
          onClick={onClose}
        />
        <Button
          label={t("common.change")}
          classes="mg ml-8"
          btnStyle="fill"
          onClick={handleUpdateMasterUser}
          state={newMastserUserId === "" ? "disable" : "default"}
        />
      </Box>
    </Modal>
  );
};
export default ChangeFileMasterModal;
